import { render, staticRenderFns } from "./ResearchReportStar.vue?vue&type=template&id=3d3fc95a&scoped=true&"
import script from "./ResearchReportStar.vue?vue&type=script&lang=js&"
export * from "./ResearchReportStar.vue?vue&type=script&lang=js&"
import style0 from "./ResearchReportStar.vue?vue&type=style&index=0&id=3d3fc95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3fc95a",
  null
  
)

export default component.exports